import { isBrowser } from 'ws-scripts/modules/environment';

export const replaceCarouselImageWithHTML = (wrapper, item) => {
	if (!isBrowser) {
		return;
	}

	const { src, html, callback, vehicle } = item;

	const callbackIsFunc = typeof callback === 'function';

	// We need HTML or a callback specified in order to proceed.
	if (!(html || callbackIsFunc)) {
		return;
	}

	// Get the insert location
	const image = wrapper.querySelector(`img[src="${src}"]`);

	// Image has already been replaced
	if (!image) {
		return;
	}

	const parent = image.parentElement;
	const height = image.clientHeight || parent.clientHeight;
	const width = image.clientWidth || parent.clientWidth;

	// Create the HTML node to insert
	const el = document.createElement('div');
	el.setAttribute('style', `height: ${height}px;`);
	el.setAttribute('data-wiapi-inserted-content', true);

	if (html) {
		el.innerHTML = html;
	}

	// Append the HTML
	parent.appendChild(el);

	// Tag the image as a placeholder for later re-use
	image.setAttribute('data-wiapi-placeholder-content', true);

	// Hide the placeholder image for now
	image.style.display = 'none';

	// Fix the blurred background image index
	const blurredBackground = parent.querySelector('.blurred-background');

	if (blurredBackground) {
		blurredBackground.style['z-index'] = -1;
	}

	parent.style['background-image'] = 'none';

	// Trigger the callback if specified
	if (callbackIsFunc) {
		callback({
			el,
			locationId: 'carousel',
			height,
			width,
			vehicle
		});
	}
};

export const replacePhotoswipeImageWithHTML = async (
	pSwipe,
	isOrientationChange = false
) => {
	const { currItem } = pSwipe;
	const { callback, html, markup } = currItem;

	const callbackIsFunc = typeof callback === 'function';

	// We need HTML or a callback specified in order to proceed.
	if (!(html || callbackIsFunc)) {
		return;
	}

	const el = currItem?.container;

	const targetLocation = el.querySelector('[data-location-id="photoswipe"]');

	if (isOrientationChange) {
		targetLocation.innerHTML = '';
	} else {
		if (targetLocation?.innerHTML?.length > html.length) {
			return;
		}

		if (markup) {
			targetLocation.innerHTML = markup;
		}
	}

	const { viewportSize, options } = pSwipe;
	const { barsSize } = options;

	// Account for Photoswipe UI features when calculating available width and height.
	const clientWidth = viewportSize.x || el.clientWidth;
	const clientHeight = viewportSize.y || el.clientHeight;
	const heightOffset = (barsSize.top + barsSize.bottom) * 1.2;

	const calculatedHeight = clientHeight - heightOffset;

	const marginTop =
		clientHeight > clientWidth
			? (clientHeight - calculatedHeight) / 2.2
			: barsSize.top;

	el.style.top = `${marginTop}px`;

	targetLocation.setAttribute('data-wiapi-inserted-content', true);

	if (callbackIsFunc) {
		callback({
			el: targetLocation,
			locationId: 'photoswipe',
			width: clientWidth,
			height: calculatedHeight
		});
	}
};

export const pauseWIAPIContent = async () => {
	window.dispatchEvent(new Event('pause-video'));
	return true;
};

export const resetWIAPIContent = async (selector) => {
	// Reset WIAPI inserted content so things like videos don't play in the background when not visible.
	const galleryLocation = document.querySelector(selector);

	if (!galleryLocation) {
		return;
	}

	// Remove API inserted HTML content
	galleryLocation
		.querySelectorAll('[data-wiapi-inserted-content]')
		.forEach((content) => {
			content.removeAttribute('data-wiapi-inserted-content');
			while (content.firstChild) {
				content.removeChild(content.lastChild);
			}
			content.remove();
		});

	// Put back placeholder content
	galleryLocation
		.querySelectorAll('[data-wiapi-placeholder-content]')
		.forEach((el) => {
			const elem = el;
			elem.style.display = 'block';
		});
};
